import {getUserHasSeenAiCaptionPopupsStatus, markUserHasSeenPopup} from '@Libraries/auto-caption-library';
import {useSelector} from 'react-redux';
import type {RootState} from '@/store';
import {useAppDispatch} from '@/hooks';
import {setHasSeenIntroPopup, setHasSeenReminderPopup} from '@/reducers/auto-caption-reducer';
import {PopupType} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

interface UseHasSeenAiCaptionIntroPopupType {
  hasSeenIntroPopup: boolean;
  hasSeenReminderPopup: boolean;
  fetchHasSeenStatus: () => Promise<void>;
  setHasSeenIntroPopup: (value: boolean) => void;
  setHasSeenReminderPopup: (value: boolean) => void;
}

const useHasSeenAiCaptionIntroPopup = (): UseHasSeenAiCaptionIntroPopupType => {
  const dispatch = useAppDispatch();
  const autoCaptionState = useSelector((state: RootState) => {
    return state.autoCaption;
  });

  const {hasSeenIntroPopup, hasSeenReminderPopup} = autoCaptionState;
  const setHasSeenIntroPopupInRedux = (value: boolean): void => {
    void markUserHasSeenPopup(PopupType.INTRO);
    dispatch(setHasSeenIntroPopup(value));
  };

  const setHasSeenReminderPopupInRedux = (value: boolean): void => {
    void markUserHasSeenPopup(PopupType.REMINDER);
    dispatch(setHasSeenReminderPopup(value));
  };

  const fetchHasSeenStatus = async (): Promise<void> => {
    const response = await getUserHasSeenAiCaptionPopupsStatus();
    dispatch(setHasSeenIntroPopup(response[PopupType.INTRO]));
    dispatch(setHasSeenReminderPopup(response[PopupType.REMINDER]));
  };

  return {
    hasSeenIntroPopup,
    hasSeenReminderPopup,
    setHasSeenIntroPopup: setHasSeenIntroPopupInRedux,
    setHasSeenReminderPopup: setHasSeenReminderPopupInRedux,
    fetchHasSeenStatus,
  };
};

export default useHasSeenAiCaptionIntroPopup;
